import { Component, OnInit } from "@angular/core";
import { OnlineAnswerService } from "../../../services/onlineanswer.service";
import { ActivatedRoute } from "@angular/router";


@Component({
  selector: 'check-answer',
  templateUrl: 'check-answer.component.html'
})
export 
  class CheckAnswerComponent implements OnInit {
  currentStatus: number;
  fDebtPrice: number;
  price: number;
  waiting: boolean = false;
  paymentLink: string = '';
  fullname: string = '';
  acceptionNumber: string = '';
  downloadLink: string = '';
  showText: boolean = false;
  messagetext: string = '';
  constructor(private onlineAnswerService: OnlineAnswerService, private route: ActivatedRoute) {

  }
  toggleText(a) {
    switch(a)
    {
      case 1:{
        if(this.currentStatus>=1)
          this.messagetext = "پذیرش قبلا انجام شده است";  
        else
          this.messagetext = "پذیرش غیر فعال است";         
      }
      break;

      case 2:{
        if(this.currentStatus>=2)
          this.messagetext = "حداقل یک نمونه از شما در سیستم ثبت شده است";         
        else
          this.messagetext = "تا کنون نمونه ای از شما در سیستم ثبت نشده است";         
      }
      break;

      case 3:{
        if(this.currentStatus>=3)
          this.messagetext = "آزمایش شما در حال انجام است";         
        else
          this.messagetext = "آزمایش شما به دلیل کامل نبودن نمونه ها انجام نشده است";         
      }
      break;

      case 4:{
        if(this.currentStatus>=4)
          this.messagetext = "آزمایش شما کنترل کیفی شده است";        
        else
          this.messagetext = "آزمایش شما کنترل کیفی نشده است ";        
      }
      break;

      case 5:{
        if(this.currentStatus>=5)
          this.messagetext = "آزمایش شما توسط پزشک امضا شده است";         
        else
          this.messagetext = "آزمایش شما توسط پزشک امضا نشده است ";         
      }
      break;

      case 6:{
        if(this.currentStatus>=6 && this.fDebtPrice>0)
          this.messagetext = "فاکتور شما تسویه نشده است لطفا آنرا پرداخت کنید";        
        else
          this.messagetext = "فاکتور شما تسویه شده است";          
      }
      break;


      case 7:{
        if(this.currentStatus>=7 && this.fDebtPrice==0)
          this.messagetext = "جواب آزمایش شما آماده می باشد";        
        else
        {
          if(this.currentStatus>=7 && this.fDebtPrice>0)
            this.messagetext = "فاکتور شما تسویه نشده است لطفا آنرا پرداخت کنید";            
          else
          this.messagetext = "جواب آزمایش شما آماده نمی باشد";
        }     
      }
      break;
    }

    this.showText = true;
  }
  ngOnInit() {
    
    //this.onlineAnswerService
    this.route.params.subscribe(p => {
      this.waiting = true;
      let acceptionNumber = p.acn.replace('-', '');
      let phoneNumber = p.phone;
      
      //this.currentStatus = 3;
      this.onlineAnswerService.GetStatusAnswer(acceptionNumber, phoneNumber).subscribe((resp:any) => {
        console.log('answer status: ', resp);
               
        this.currentStatus =resp.fAnswerStatusMilestone;
        this.price = resp.fDebtPrice;
        this.fullname = resp.fFirstName + ' ' + resp.fLastName;
        this.acceptionNumber = resp.fAcceptionNumber;
        if (resp.fDebtPrice > 0) {
          this.fDebtPrice = 1;
          var thisSiteUrl ="http://valiasrlab.com";// document.location.origin;
          var fReturnUrlSuccess = thisSiteUrl + '/PaymentSucceeded?key=' + resp.fAcceptionNumber + '_' + phoneNumber;
          var fReturnUrlFailure = thisSiteUrl + '/PaymentFailure';
         
          this.paymentLink = this.onlineAnswerService.GetAcceptionPaymentUrl(resp.fCode.toString(), fReturnUrlSuccess, fReturnUrlFailure);
          
        }
        else{
          this.fDebtPrice =0;
        }
        if (this.currentStatus == 7) {
          
          this.downloadLink ="http://api.valiasrlab.com/Content/PdfFiles/"+resp.fAcceptionNumber + '_' + phoneNumber+".pdf";// this.onlineAnswerService.GetDownloadAnswerUrl(acceptionNumber, phoneNumber);
          this.waiting = false;
        }
        else{
          this.waiting = false;
        }
      });
    });
  }
}
